import { commonOptions } from '@/config/options'

import { addDialog, logDialog } from './_dialogs'
import { TdlDeviceSNStatus } from '@/config'
import { getCommonOptionLabel } from '@/utils'

export default {
  body: {
    type: 'crud',
    actions: {
      query: {
        api: '/sys/admin/device/device-sn/pageList'
      },
      add: {
        api: '/sys/admin/device/device-sn/generate/single',
        dialog: addDialog(true)
      },
      batchAdd: {
        api: '/sys/admin/device/device-sn/generate/batch',
        dialog: addDialog(false)
      },
      log: { label: '日志', dialog: logDialog() },
      discard: {
        label: '作废',
        api: '/sys/admin/device/device-sn/changeStatus',
        payload: { snCode: '${data.row.snCode}', action: 'VOID' }
      },
      recover: {
        label: '恢复',
        api: '/sys/admin/device/device-sn/changeStatus',
        payload: { snCode: '${data.row.snCode}', action: 'RESTORE' }
      },
      export: {
        api: {
          url: '/sys/admin/device/device-sn/pageList/cursor',
          responseTransform: (res: any) => {
            res.list = (res.list || []).map((it: any) => {
              it.status = getCommonOptionLabel(commonOptions.tdlDeviceSNStatus, it.status)
              return { ...it }
            })

            return res
          }
        },
        fileName: 'SN列表'
      }
    },
    search: {
      items: [
        { type: 'input', prop: 'snCode', label: '设备SN' },
        {
          type: 'fuzzy-select',
          prop: 'manufacturerCode',
          label: '厂商',
          api: '/sys/admin/device/manufacturer/listEnabled',
          optionValueProp: 'manufacturerCode',
          optionLabelProp: 'manufacturerName',
          triggerFocus: true,
          clearable: true,
          remote: false
        },
        {
          type: 'select',
          prop: 'deviceTypeCode',
          label: '类型',
          options: commonOptions.tdlDeviceType,
          clearable: true,
          remote: false
        },
        {
          label: '型号',
          type: 'fuzzy-select',
          prop: 'modelCode',
          api: '/sys/admin/device/device-model/listEnabled',
          optionValueProp: 'modelCode',
          optionLabelProp: 'modelName',
          triggerFocus: true,
          clearable: true,
          remote: false
        },
        { type: 'select', prop: 'status', label: '状态', options: 'tdlDeviceSNStatus' }
      ]
    },
    toolbar: {
      items: [
        { action: 'batchAdd', label: '批量生成' },
        { action: 'add', label: '单个生成' },
        { action: 'export', label: '导出当前筛选结果' }
      ]
    },
    table: {
      innerAttrs: { rowKey: 'snCode' },
      operation: {
        width: 120,
        items: [
          { action: 'log' },
          {
            action: 'discard',
            visibleOn: `this.data.row.status !== '${TdlDeviceSNStatus.VOIDED}' && this.data.row.status !== '${TdlDeviceSNStatus.ACTIVATED}'`
          },
          { action: 'recover', visibleOn: `this.data.row.status === '${TdlDeviceSNStatus.VOIDED}'` }
        ]
      },
      columns: [
        { label: 'SN', prop: 'snCode', width: 200 },
        { label: '厂商', prop: 'manufacturerName', width: 150 },
        { label: '类型', prop: 'deviceTypeName', width: 120 },
        { label: '型号', prop: 'modelName', minWidth: 180 },
        { label: '状态', prop: 'status', formatter: { name: 'enumStr', options: 'tdlDeviceSNStatus' }, width: 100 },
        { label: '生成时间', prop: 'gmtCreate', width: 150 }
      ]
    }
  }
}
